import language from "i18next";
import cookies from "js-cookie";
import Backend from "i18next-http-backend";
import i18n from "shared/helpers/language";
import { atom, useRecoilValue } from "recoil";
import { initReactI18next } from "react-i18next";
import BrowserLanguageDetector from "i18next-browser-languagedetector";

type LanguageCode = "ar" | "en";

export enum ServerLanguage {
  en = 1,
  ar = 2,
}

interface Language {
    id:number,
    name: string;
    code: LanguageCode;
    dir?: "rtl" | "ltr";
}


language
    .use(Backend)
    .use(BrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        initImmediate: true,
        debug:false,
        fallbackLng: 'en',
        supportedLngs: ['en', 'ar'],
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: '/translations/{{lng}}.json'
        },
        detection: {
            order: ["cookie", 'htmlTag'],
            caches: ['cookie']
        }
    });

export const LanguageAtom = atom({
    key: "lang-code",
    default: cookies.get("i18next") || "en",
    effects: [
        ({ onSet }) => {
            onSet((newCode) => {
                i18n.changeLanguage(newCode);
            });
        },
    ],
});

export const languages: Language[] = [
    {
        id:1,
        code: "en",
        name: "English",
    },
    {
        id:2,
        code: "ar",
        name: "العربية",
        dir: "rtl",
    },
];

export const useLocalize = () => {
    const languageCode = useRecoilValue(LanguageAtom);
    const currentLanguage = languages.find((l) => l.code === languageCode);

    return { currentLanguage, languages };
};


export default language;

